import { useMutation } from '@tanstack/react-query';
import { POST, POST_CLAIM_UPDATE } from '../../../../services';
import { openAlert } from '../../../../components/alert/useAlert';
import { ROUTES_PATH } from '../../../../resources/routes-name';
import { navigateTo } from '../../../../utils/navigation';
import { convertYearInputToPayload } from '../../../../functions/convert';
import {
  appendConfirmSimilarImage,
  appendUploadFile,
  confirmSimilarImage,
  postWithImageCheck,
  SAVE_WARNING_KEY,
  showSaveWarnings,
} from '../../../../functions/imageUpload';

// กลับไปหน้ารายละเอียดของเคลมที่แก้ (ClaimDetail อ่าน claimCode จาก ?code=)
const navigateToClaimDetail = (claimCode) =>
  navigateTo({
    pathname: ROUTES_PATH.ROUTE_CLAIM_DETAIL.PATH,
    search: claimCode ? `?code=${encodeURIComponent(claimCode)}` : undefined,
  });

export const onUploadFile = ({ onSuccessCallBack }) => {
  const mutation = useMutation({
    mutationFn: async ({
      claimImageUrl,
      receiptImageUrl,
      claimId,
      customerCode,
      detail1,
      detail2,
      breakdownId,
      addressLine1,
      addressLine2,
      subDistrictId,
      remark,
      zipCode,
      other,
      storeId,
      channelClaimId,
      bookingDate,
      noDeductWarranty,
      confirmSimilarImage: isConfirmSimilarImage,
    }) => {
      const formData = new FormData();
      appendUploadFile(formData, 'claimImage', claimImageUrl);
      appendUploadFile(formData, 'receiptImage', receiptImageUrl);
      appendConfirmSimilarImage(formData, isConfirmSimilarImage);
      formData.append('claimId', claimId);
      formData.append('customerCode', customerCode);
      formData.append('detail1', detail1);
      formData.append('detail2', detail2);
      formData.append('breakdownId', breakdownId);
      formData.append('addressLine1', addressLine1);
      formData.append('addressLine2', addressLine2);
      formData.append('subDistrictId', subDistrictId);
      formData.append('zipCode', zipCode);
      formData.append('remark', remark);
      formData.append('other', other);
      formData.append('storeId', storeId);
      formData.append('channelClaimId', channelClaimId);
      formData.append('bookingDate', convertYearInputToPayload(bookingDate));
      formData.append('noDeductWarranty', noDeductWarranty === 'Y' ? 'true' : 'false');
      const response = await postWithImageCheck(() => POST(POST_CLAIM_UPDATE(), formData));
      if (onSuccessCallBack) onSuccessCallBack(response);
      return response;
    },
    onSuccess: (response, variables) => {
      const claimCode = variables?.claimCode || response?.result?.item?.claimCode;
      if (
        showSaveWarnings(response, [SAVE_WARNING_KEY.IMAGE_HASH], () =>
          navigateToClaimDetail(claimCode),
        )
      )
        return;
      openAlert({ model: 'message', type: 'success', message: response.message });
      setTimeout(() => {
        navigateToClaimDetail(claimCode);
      }, 1000);
    },
    onError: (error, variables) => {
      confirmSimilarImage(error, () =>
        mutation.mutate({ ...variables, confirmSimilarImage: true }),
      );
    },
  });
  return mutation;
};
